var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "green-border-box in-padd white-bg" },
    [
      _vm._m(0),
      _c("div", { staticClass: "row mt15" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _vm.busy
            ? _c("div", { staticClass: "text-center" }, [
                _vm._v("Loading links...")
              ])
            : !_vm.links || _vm.links.length === 0
            ? _c("div", { staticClass: "text-center mt20" }, [
                _c("h3", [_vm._v("No links yet.")]),
                _c("p", [_vm._v("Create a link using the button above.")])
              ])
            : _c("div", { staticClass: "table-responsive" }, [
                _c("table", { staticClass: "table table-bordered" }, [
                  _vm._m(1),
                  _c(
                    "tbody",
                    _vm._l(_vm.links, function(link) {
                      return _c("tr", { key: link.id }, [
                        _c("td", [
                          _vm._v(_vm._s(_vm.getLinkTypeLabel(link.link_type)))
                        ]),
                        _c("td", [_vm._v(_vm._s(link.title || "—"))]),
                        _c("td", [_vm._v(_vm._s(link.description || "—"))]),
                        _c(
                          "td",
                          [
                            link.link_type === "watch" ||
                            link.link_type === "review"
                              ? [
                                  link.website_link
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: link.website_link,
                                            target: "_blank",
                                            rel: "noopener noreferrer"
                                          }
                                        },
                                        [_vm._v(_vm._s(link.website_link))]
                                      )
                                    : _c("span", [_vm._v("—")])
                                ]
                              : link.link_type === "app-install"
                              ? [
                                  link.ios_link
                                    ? _c("div", [
                                        _c(
                                          "span",
                                          { staticClass: "text-muted" },
                                          [_vm._v("iOS:")]
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: link.ios_link,
                                              target: "_blank",
                                              rel: "noopener noreferrer"
                                            }
                                          },
                                          [_vm._v(_vm._s(link.ios_link))]
                                        )
                                      ])
                                    : _vm._e(),
                                  link.android_link
                                    ? _c("div", [
                                        _c(
                                          "span",
                                          { staticClass: "text-muted" },
                                          [_vm._v("Android:")]
                                        ),
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: link.android_link,
                                              target: "_blank",
                                              rel: "noopener noreferrer"
                                            }
                                          },
                                          [_vm._v(_vm._s(link.android_link))]
                                        )
                                      ])
                                    : _vm._e(),
                                  !link.ios_link && !link.android_link
                                    ? _c("span", [_vm._v("—")])
                                    : _vm._e()
                                ]
                              : _c("span", [_vm._v("—")])
                          ],
                          2
                        ),
                        _c("td", { staticClass: "text-center actions-cell" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn-positive btn-sm",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push(
                                    "/brand/links/" + link.id + "/edit"
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  Edit\n                "
                              )
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn-negative btn-sm",
                              attrs: {
                                type: "button",
                                "data-toggle": "modal",
                                "data-target": "#delete-link-popup"
                              },
                              on: {
                                click: function($event) {
                                  _vm.linkToDelete = link
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  Delete\n                "
                              )
                            ]
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
        ])
      ]),
      _c("CreateLinkPopup", {
        attrs: { popupId: "create-link-popup", brandId: _vm.brandId },
        on: { created: _vm.getLinks }
      }),
      _c("DeleteLinkPopup", {
        attrs: {
          popupId: "delete-link-popup",
          brandId: _vm.brandId,
          link: _vm.linkToDelete
        },
        on: { deleted: _vm.getLinks }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c(
          "button",
          {
            staticClass: "btn-positive pull-right",
            attrs: {
              "data-toggle": "modal",
              "data-target": "#create-link-popup"
            }
          },
          [_vm._v("\n        Create New Link\n      ")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Link Type")]),
        _c("th", [_vm._v("Title")]),
        _c("th", [_vm._v("Description")]),
        _c("th", [_vm._v("Link(s)")]),
        _c("th", { staticClass: "text-center" }, [_vm._v("Actions")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }